<template>
  <!-- <tbody :class="[showDetail ? 'isActive' : '', 'tbody']" v-if="invoice"> -->
  <tbody class="tbody" v-if="invoice">
    <tr>
      <td style="width: 40px">
        <v-checkbox
          v-model="invoice.selected"
          style="padding: 0; float: left; width: 30px"
        ></v-checkbox>
      </td>
      <td @click="showDetail = !showDetail">{{ invoice.invoiceNo }}</td>
      <td @click="showDetail = !showDetail">{{ invoice.invoiceDateStr }}</td>
      <td @click="showDetail = !showDetail">{{ invoice.dueDateStr }}</td>
      <!-- <td @click="showDetail = !showDetail">
        {{ invoice.createdAt | moment("DD MMM YYYY hh:mm a") }}
      </td> -->
      <td @click="showDetail = !showDetail">
        <span v-if="invoice.clientName">
          <div v-if="invoice.clientName.length < 24">
            {{ invoice.clientName }}
          </div>
          <div v-else>{{ invoice.clientName.substring(0, 24) + ".." }}</div>
        </span>
        {{
          invoice.passenger && invoice.passenger.name != null
            ? invoice.passenger.name
            : null
        }}
      </td>
      <td @click="showDetail = !showDetail">
        <span v-if="invoice.clientEntity && invoice.clientEntity.name">
          <div v-if="invoice.clientEntity.name.length < 24">
            {{ invoice.clientEntity.name }}
          </div>
          <div v-else>{{ invoice.clientEntity.name.substring(0, 24) + ".." }}</div>
        </span>
      </td>
      <td @click="showDetail = !showDetail">
        {{ invoice.fare.currency }} {{ invoice.fare.total }}
      </td>
      <td @click="showDetail = !showDetail">
        {{ collectedFunc(invoice) }}
      </td>
      <td @click="showDetail = !showDetail">
        <span v-show="invoice.writeOff != null && invoice.writeOff > 0">
          {{ $i18n.t("Write Off") }}: {{ invoice.writeOff }}
        </span>
      </td>
      <td @click="showDetail = !showDetail">
        <span v-show="invoice.invoiceType == null && invoice.creationMode == 0">
          {{ $i18n.t("Manual") }}
        </span>
        <p v-show="invoice.proforma">
          <b>{{ $i18n.t("Proforma") }}</b>
        </p>
      </td>
      <td @click="showDetail = !showDetail">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" x-small :color="statusColor">
              <h3>
                <span>{{ statusStr }}</span>
                <v-icon>mdi-menu-down</v-icon>
              </h3>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-on:click="changeStatus(invoice, 0)"
              v-show="invoice.showMarkCreated"
            >
              <v-list-item-title>{{ $i18n.t("Unverify") }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-on:click="changeStatus(invoice, 1)"
              v-show="invoice.showMarkVerified"
            >
              <v-list-item-title>{{ $i18n.t("Verify") }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-on:click="changeStatus(invoice, 3)"
              v-show="invoice.showMarkPaid"
            >
              <v-list-item-title>{{
                $i18n.t("Payment Collected")
              }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-on:click="changeStatus(invoice, 4)"
              v-show="invoice.showMarkCancelled"
            >
              <v-list-item-title>{{ $i18n.t("Cancelled") }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </td>
      <td @click="showDetail = !showDetail" style="max-width: 60px">
        <v-btn
          text
          fab
          x-small
          v-if="invoice.creationMode != 0"
          color="blue"
          :to="'/sales/invoice/' + invoice._id"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          text
          fab
          x-small
          v-if="invoice.creationMode == 0"
          color="blue"
          :to="'/sales/invoice/manual/' + invoice._id"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          text
          fab
          x-small
          :title="$i18n.t('Print Invoice')"
          small
          color="primary"
          @click="invDownload()"
        >
          <v-icon>mdi-printer</v-icon>
        </v-btn>
        <v-btn
          text
          fab
          x-small
          color="cyan lighten-2"
          :title="$i18n.t('Email Invoice')"
          @click="invEmail()"
        >
          <v-icon>mdi-email</v-icon>
        </v-btn>
        <z-confirm-button
          v-if="invoice.showDelete"
          color="red lighten-1 float-right"
          x-small
          fab
          text
          dark
          :loading="loading"
          :message="$i18n.t('Do you want to delete this invoice ?')"
          @click="deleteInvoice()"
          style="display: inline"
          class="mt-1"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
      </td>
    </tr>
    <!-- <tr v-if="showDetail" style="background-color: #e0f2f1">
      <td colspan="4"></td>
      <td colspan="4"></td>
    </tr> -->

    <!-- <v-card-text class="py-0">
      <v-row v-if="invoice">
        <v-col cols="12" md="1" class="body-2">
          <h4></h4>
        </v-col>

        <v-col cols="12" md="3" sm="1" class="body-2">
          <v-icon>mdi-calendar</v-icon>

          <br />
          <v-icon>mdi-city</v-icon>

          <br />
          {{ $i18n.t("Created By") + ": " + invoice.createdByName }}
          <small v-show="invoice.ofSupplier" :title="$i18n.t('Supplier')">
            {{ invoice.vendorName }}
          </small>
        </v-col>

        <v-col cols="12" md="2" class="body-2">
          <v-icon v-if="invoice.clientName != null" color="blue"
            >mdi-account-box-outline</v-icon
          >
          {{ invoice.clientName != null ? invoice.clientName : null }}
          <v-icon v-if="invoice.forIndividual" color="green"
            >mdi-account-circle</v-icon
          >
          {{
            invoice.passenger && invoice.passenger.name != null
              ? invoice.passenger.name
              : null
          }}
          <br />
          <v-icon
            v-if="
              invoice.clientEntity != null && invoice.clientEntity.name != null
            "
            :title="$i18n.t('Client Entity')"
          ></v-icon>
          {{ invoice.clientEntity ? invoice.clientEntity.name : null }}
        </v-col>

        <v-col cols="12" md="2" class="body-2">
          <p v-show="invoice.fare.total > 0">
            {{ invoice.fare.currency }} {{ invoice.fare.total }}
          </p>

          <p
            v-show="
              invoice.toBeCollected != null ||
              invoice.toBeCollected != undefined
            "
          >
            {{ $i18n.t("Collected") }}: {{ collectedFunc(invoice) }}
          </p>
        </v-col>

        <v-col cols="12" md="1" class="body-2"> </v-col>

        <v-col cols="12" md="1" class="body-2"> </v-col>

        <v-col cols="12" xs="1" sm="2" md="2" class="text-center pl-0">
        </v-col>
      </v-row>
    </v-card-text> -->
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "InvoiceRow",
  props: {
    value: {
      default: null,
    },
    selected: {
      default: false,
    },
  },
})
export default class InvoiceRow extends Vue {
  invoice = null;
  showDetail = false;
  loading = false;

  invDownload() {
    this.$emit("invDownload", this.invoice);
  }

  invEmail() {
    this.$emit("invEmail", this.invoice);
  }

  @Watch("selected")
  onSelectedChange(val) {
    this.invoice.selected = val;
  }

  async deleteInvoice() {
    this.loading = true;
    try {
      await doGet(`/api/invoice/${this.invoice._id}/delete`);
      common.showMessage("Invoice deleted.");
      this.$emit("reload", true);
      this.loading = false;
    } catch (e) {
      this.loading = false;
      common.setError(e.message);
    }
  }

  get statusStr() {
    if (this.invoice.status == 0) {
      return this.$i18n.t("Draft");
    }
    if (this.invoice.status == 1) {
      return this.$i18n.t("Ready");
    }
    if (this.invoice.status == 3) {
      return this.$i18n.t("Payment Collected");
    }
    if (this.invoice.status == 4) {
      return this.$i18n.t("Cancelled");
    }
    if (this.invoice.status == 5) {
      return this.$i18n.t("Partially Collected");
    }
    return "";
  }

  get statusColor() {
    if (this.invoice.status == 0) {
      return "default";
    }
    if (this.invoice.status == 1) {
      return "cyan lighten-2";
    }
    if (this.invoice.status == 3) {
      return "green";
    }
    if (this.invoice.status == 4) {
      return "red";
    }
    if (this.invoice.status == 5) {
      return "primary";
    }
    return "";
  }

  get notifications() {
    const list = [];
    if (this.invoice.showMarkCreated) {
      const t = {};
      t.name = this.$i18n.t("Unverify");
      t.changeTo = 0;
      list.push(t);
    }
    if (this.invoice.showMarkVerified) {
      const t = {};
      t.name = this.$i18n.t("Verify");
      t.changeTo = 1;
      list.push(t);
    }
    if (this.invoice.showMarkPaid) {
      const t = {};
      t.name = this.$i18n.t("Payment Collected");
      t.changeTo = 3;
      list.push(t);
    }
    if (this.invoice.showMarkCancelled) {
      const t = {};
      t.name = this.$i18n.t("Cancelled");
      t.changeTo = 4;
      list.push(t);
    }
    return list;
  }

  async changeStatus(invoice, status) {
    const urlStatus =
      "/api/invoice/" + invoice._id + "/status/" + status + "/update";
    this.loading = true;
    try {
      await doGet(urlStatus);
      common.showMessage("Status Updated Successfully");
      this.$emit("reload", true);
      this.loading = false;
    } catch (e) {
      common.setError(e.message);
      this.loading = false;
    }
  }

  collectedFunc(invoice) {
    let temp = 0;
    if (
      invoice.fare.total != null &&
      invoice.toBeCollected != null &&
      invoice.fare.total - invoice.toBeCollected > 0
    ) {
      temp = this.roundOffToTwoDecimal(
        invoice.fare.total - invoice.toBeCollected
      );
    }
    return temp;
  }

  roundOffToTwoDecimal(num) {
    return Math.round(num * 100) / 100;
  }

  mounted() {
    if (this.value) {
      this.invoice = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.invoice = val;
  }
}
</script>

<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
</style>